import type { Sticker } from '../types';

export const pets: Sticker[] = [
  {
    id: 13001,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/001-pet-love.png',
    name: 'Miłość do Zwierząt',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13002,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/002-turtle.png',
    name: 'Żółwik',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13003,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/003-cat.png',
    name: 'Kotek',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13004,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/004-hamster.png',
    name: 'Chomik',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13005,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/005-dog.png',
    name: 'Piesek',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13006,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/006-cat.png',
    name: 'Kot z Kłębkiem',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13007,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/007-veterinary.png',
    name: 'Weterynarz',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13008,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/008-cat.png',
    name: 'Kot w Koszyku',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13009,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/009-fish.png',
    name: 'Rybka',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13010,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/010-dog.png',
    name: 'Pies z Piłką',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13011,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/011-cat.png',
    name: 'Kot na Poduszce',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13012,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/012-dog.png',
    name: 'Pies na Spacerze',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13013,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/013-dog.png',
    name: 'Pies z Kością',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13014,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/014-dog.png',
    name: 'Pies w Budzie',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13015,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/015-hamster.png',
    name: 'Chomik w Kołowrotku',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13016,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/016-washing.png',
    name: 'Mycie Pupila',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13017,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/017-bird.png',
    name: 'Papuga',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13018,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/018-fish.png',
    name: 'Akwarium',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13019,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/019-cat.png',
    name: 'Kot z Miseczką',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 13020,
    url: 'https://stickers.nauczniaczek.pl/colections/13474376-pets/png/020-cat.png',
    name: 'Kot z Zabawką',
    category: 'pets',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];